<template>
  <div :class="className">
    <div 
      class="sf-field-error-message tw-text-right" 
      :class="{ 'prevent-wrap': preventWrap }"
    >
      &nbsp; {{ errorMessage }}
    </div>
  </div>
</template>

<style scoped lang="postcss">

.prevent-wrap {
  @apply tw-text-nowrap;
}

.has-error .sf-field-error-message {
  @apply tw-text-danger;
}
</style>

<script lang="ts">
import getErrorMessage from "@/func/form/getErrorMessage";
import { Dict, SfFormFieldErrorCode } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {},
  props: {
    errors: {
      type: Object as PropType<SfFormFieldErrorCode[]>,
      required: true,
    },
    customErrors: {
      type: Object as PropType<Dict<string>>,
      default: () => null,
    },
    className: { type: String, default: "sf-field-error-container" },
    preventWrap: { type: Boolean, default: true },
  },
  data() {
    return {};
  },
  computed: {
    hasError(): boolean {
      return this.errors.length > 0 ? true : false;
    },
    errorMessage(): string {
      return this.hasError
        ? getErrorMessage(this.errors[0], this.customErrors)
        : " ";
    },
  },
});
</script>
